import React, { Component } from 'react'
import QueryManager from './Query'
import { get } from 'lodash'
import gql from 'graphql-tag'
import { Auth } from 'aws-amplify'

const QUERY_GET_SALES_CHANNELS_BY_USER = gql`
  query getUserPickers ($size: Int, $filters: [FilterInput] ) {
    users(size: $size, filters: $filters) {
      results {
        ... on Picker {
          id
          firstName
          lastName
          email
          phone
          status
          document
          role
          status
          salesChannels {
            id
            isActive
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`

export default class GetUserSalesChannels extends Component {
  state = {
    loading: false,
    salesChannelFilter: null
  }

  async componentDidMount () {
    try {
      this.setState({ loading: true })
      const currentUserInfo = await Auth.currentSession()
      const salesChannelFilter = {
        field: 'email',
        value: get(currentUserInfo, 'idToken.payload.email')
      }
      this.setState({ salesChannelFilter, loading: false })
    } catch (error) {
      console.log(error, this.setState({ loading: false }))
    }
  }

  render () {
    const { salesChannelFilter } = this.state
    const { children } = this.props
    if (!salesChannelFilter) return null
    return (
      <QueryManager query={QUERY_GET_SALES_CHANNELS_BY_USER} variables={{ filters: salesChannelFilter }} fetchPolicy='cache' pollInterval={60000}>
        {
          ({ data, loading }) => {
            const salesChannels = get(data, 'users.results[0].salesChannels', [])
            return children({ data, salesChannels, loading })
          }
        }
      </QueryManager>
    )
  }
}

export {
  QUERY_GET_SALES_CHANNELS_BY_USER
}